import React from 'react';
import { useSelector } from 'react-redux';
import { Title, Typeform } from '@minerva-analytics/pantheon';
import { BodyText, TypeformContainer } from './SubscriberJump.styles';

const SubscribeJump = () => {
  const email = useSelector((state) => state.subscription.email);

  return (
    <>
      <Title>You&apos;re almost there, confirm your email!</Title>
      <BodyText>
        {`Please check ${email} for a message from Cooking & Cocktails
        to confirm your email.`} <br /><br />
        Don&apos;t forget to check your junk folder - just in case!
      </BodyText>
      <TypeformContainer>
        <Typeform formID='ALBm5d3o' parameters={{email}} />
      </TypeformContainer>
    </>
  );
};

export default SubscribeJump;
